import { render, staticRenderFns } from "./DryingTemplate.vue?vue&type=template&id=2cf63e8e"
import script from "./DryingTemplate.vue?vue&type=script&lang=js"
export * from "./DryingTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports